import { render, staticRenderFns } from "./Cards1.vue?vue&type=template&id=5f44c566"
import script from "./Cards1.vue?vue&type=script&lang=js"
export * from "./Cards1.vue?vue&type=script&lang=js"
import style0 from "./Cards1.vue?vue&type=style&index=0&id=5f44c566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports